import { fontSize, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import {
  ICON_BUTTON__BUTTON_CLASS,
  ICON_BUTTON__ICON_CLASS,
} from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import {
  ACCORDION__HEADING_CLASS,
  ACCORDION__TITLE_CLASS,
} from 'src/components/molecules/Accordion';

const { text, spacing } = theme;

export const DELIVERY_SUMMARY_ID = 'delivery-summary';

export const deliveryArea = css`
  padding: ${pxToRem(35)} 0;
  grid-column: span 12;
  border-bottom: ${pxToRem(1)} solid var(--neutral-black-30);
  border-top: ${pxToRem(1)} solid var(--neutral-black-30);

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 2 / -2;
    `,
  )}

  .${ACCORDION__TITLE_CLASS} {
    ${fontSize(text.HEADING.XS)};
    font-weight: 600;
  }

  .${ACCORDION__HEADING_CLASS}, .${ICON_BUTTON__BUTTON_CLASS} {
    width: 100%;
  }

  .${ICON_BUTTON__BUTTON_CLASS} {
    justify-content: space-between;
    align-items: center;

    .${ICON_BUTTON__ICON_CLASS} {
      margin: 0;
      align-self: auto;
    }
  }
`;

export const deliveryAreaSection = css`
  grid-column: span 12;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: span 6;
    `,
  )};
`;

export const heading = css`
  ${fontSize(text.BODY.MD)};
  margin-top: ${pxToRem(spacing.xxl)};
  margin-bottom: ${pxToRem(spacing.lg)};

  &:first-child {
    margin-top: 0;
  }
`;
